import { GET_BANKING_CAPACITY_ALL, GET_BANKING_SEARCH, RESET_BANKING_CAPACITY } from './types';

const initialState = {
}

const bankingCapacityReducer = (state = initialState, action) => {
    if (action.type) {
        switch (action.type) {
            case GET_BANKING_CAPACITY_ALL:
                return {
                    ...state,
                    allBankingCapacity: action.payload
                }
            case GET_BANKING_SEARCH:
                return {
                    ...state,
                    allBankingSearch: action.payload
                }
            case RESET_BANKING_CAPACITY:
                return initialState;
            default:
                {
                    return state;
                }
        }
    }
}

export default bankingCapacityReducer;